import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "card-header log-header" };
const _hoisted_2 = { class: "log-toolbar" };
const _hoisted_3 = { class: "log-body" };
const _hoisted_4 = {
    key: 0,
    class: "log-empty"
};
const _hoisted_5 = {
    key: 1,
    class: "log-list"
};
const _hoisted_6 = { class: "log-time" };
const _hoisted_7 = {
    key: 0,
    class: "log-size"
};
const _hoisted_8 = {
    key: 1,
    class: "log-rtt"
};
const _hoisted_9 = { class: "log-data" };
const _hoisted_10 = {
    key: 2,
    class: "log-note"
};
import { computed, nextTick, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { ElMessage } from 'element-plus';
import { CopyDocument, Delete, Download, ChatLineSquare } from '@element-plus/icons-vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DataLogPanel',
    props: {
        channel: {},
        height: { default: '430px' }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const scrollbarRef = ref(null);
        const viewMode = ref('HEX');
        const log = computed(() => store.getters[`${props.channel}/log`]);
        // 三个开关通过 getter/setter 双向绑定到 store，保证切换页面后设置不丢失
        const autoScroll = computed({
            get: () => store.getters[`${props.channel}/autoScroll`],
            set: (v) => store.dispatch(`${props.channel}/setAutoScroll`, v)
        });
        const paused = computed({
            get: () => store.getters[`${props.channel}/paused`],
            set: (v) => store.dispatch(`${props.channel}/setPaused`, v)
        });
        const maxEntries = computed({
            get: () => store.getters[`${props.channel}/maxEntries`],
            set: (v) => store.dispatch(`${props.channel}/setMaxEntries`, v)
        });
        const dirLabel = (dir) => ({ tx: '发送', rx: '接收', info: '提示', error: '错误' })[dir];
        // 新日志到达后滚到底部。用 nextTick 等 DOM 更新完成，
        // 直接给一个足够大的值即可命中底部，避免读取 scrollHeight 触发重排。
        watch(() => log.value.length, async () => {
            if (!autoScroll.value)
                return;
            await nextTick();
            scrollbarRef.value?.setScrollTop(log.value.length * 40 + 10000);
        });
        function buildText() {
            return log.value
                .map((it) => {
                const parts = [`[${it.time}]`, dirLabel(it.dir)];
                if (it.rttMs !== undefined)
                    parts.push(`${it.rttMs}ms`);
                const data = viewMode.value === 'HEX' ? it.hex : it.ascii;
                if (data)
                    parts.push(data);
                if (it.note)
                    parts.push(`// ${it.note}`);
                return parts.join(' ');
            })
                .join('\n');
        }
        async function copyAll() {
            if (log.value.length === 0) {
                ElMessage.warning('没有可复制的内容');
                return;
            }
            const text = buildText();
            try {
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(text);
                }
                else {
                    // 非安全上下文下 Clipboard API 不可用，退回到 execCommand
                    const ta = document.createElement('textarea');
                    ta.value = text;
                    ta.style.position = 'fixed';
                    ta.style.opacity = '0';
                    document.body.appendChild(ta);
                    ta.select();
                    document.execCommand('copy');
                    document.body.removeChild(ta);
                }
                ElMessage.success(`已复制 ${log.value.length} 条记录`);
            }
            catch {
                ElMessage.error('复制失败，请手动选择文本');
            }
        }
        function exportLog() {
            if (log.value.length === 0) {
                ElMessage.warning('没有可导出的内容');
                return;
            }
            const blob = new Blob([buildText()], { type: 'text/plain;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `modbus-${props.channel}-${Date.now()}.log`;
            a.click();
            URL.revokeObjectURL(url);
            ElMessage.success('日志已导出');
        }
        function clear() {
            store.dispatch(`${props.channel}/clearLog`);
        }
        return (_ctx, _cache) => {
            const _component_el_checkbox = _resolveComponent("el-checkbox");
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_input_number = _resolveComponent("el-input-number");
            const _component_el_radio_button = _resolveComponent("el-radio-button");
            const _component_el_radio_group = _resolveComponent("el-radio-group");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_icon = _resolveComponent("el-icon");
            const _component_el_scrollbar = _resolveComponent("el-scrollbar");
            const _component_el_card = _resolveComponent("el-card");
            return (_openBlock(), _createBlock(_component_el_card, { class: "mb-card log-card" }, {
                header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "card-title" }, "收发数据", -1)),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_el_checkbox, {
                                modelValue: autoScroll.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((autoScroll).value = $event)),
                                label: "自动滚动",
                                size: "small"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_el_tooltip, {
                                content: "暂停后新报文不再记入日志，便于查看历史",
                                placement: "top"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_el_checkbox, {
                                        modelValue: paused.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((paused).value = $event)),
                                        label: "暂停",
                                        size: "small"
                                    }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                            }),
                            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "toolbar-label" }, "最大条数", -1)),
                            _createVNode(_component_el_input_number, {
                                modelValue: maxEntries.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((maxEntries).value = $event)),
                                min: 10,
                                max: 5000,
                                step: 50,
                                size: "small",
                                "controls-position": "right",
                                style: { "width": "108px" }
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_el_radio_group, {
                                modelValue: viewMode.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((viewMode).value = $event)),
                                size: "small"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_el_radio_button, { value: "HEX" }, {
                                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                                            _createTextVNode("HEX", -1)
                                        ])),
                                        _: 1,
                                        __: [4]
                                    }),
                                    _createVNode(_component_el_radio_button, { value: "ASCII" }, {
                                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                                            _createTextVNode("ASCII", -1)
                                        ])),
                                        _: 1,
                                        __: [5]
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                                size: "small",
                                type: "primary",
                                icon: _unref(CopyDocument),
                                onClick: copyAll
                            }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                    _createTextVNode(" 复制 ", -1)
                                ])),
                                _: 1,
                                __: [6]
                            }, 8, ["icon"]),
                            _createVNode(_component_el_button, {
                                size: "small",
                                type: "success",
                                icon: _unref(Download),
                                onClick: exportLog
                            }, {
                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                    _createTextVNode(" 导出 ", -1)
                                ])),
                                _: 1,
                                __: [7]
                            }, 8, ["icon"]),
                            _createVNode(_component_el_button, {
                                size: "small",
                                type: "warning",
                                icon: _unref(Delete),
                                onClick: clear
                            }, {
                                default: _withCtx(() => _cache[8] || (_cache[8] = [
                                    _createTextVNode("清空", -1)
                                ])),
                                _: 1,
                                __: [8]
                            }, 8, ["icon"])
                        ])
                    ])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_scrollbar, {
                            ref_key: "scrollbarRef",
                            ref: scrollbarRef,
                            height: _ctx.height
                        }, {
                            default: _withCtx(() => [
                                (log.value.length === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createVNode(_component_el_icon, { size: 34 }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(ChatLineSquare))
                                            ]),
                                            _: 1
                                        }),
                                        _cache[11] || (_cache[11] = _createElementVNode("p", null, "暂无数据", -1)),
                                        _cache[12] || (_cache[12] = _createElementVNode("span", null, "建立连接后发送请求，收发报文会实时显示在这里", -1))
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(log.value, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: item.id,
                                                class: _normalizeClass(["log-row", `dir-${item.dir}`])
                                            }, [
                                                _createElementVNode("span", _hoisted_6, _toDisplayString(item.time), 1),
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(["log-tag", `tag-${item.dir}`])
                                                }, _toDisplayString(dirLabel(item.dir)), 3),
                                                (item.size)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.size) + "B", 1))
                                                    : _createCommentVNode("", true),
                                                (item.rttMs !== undefined)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.rttMs) + "ms", 1))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("span", _hoisted_9, _toDisplayString(viewMode.value === 'HEX' ? item.hex : item.ascii), 1),
                                                (item.note)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.note), 1))
                                                    : _createCommentVNode("", true)
                                            ], 2));
                                        }), 128))
                                    ]))
                            ]),
                            _: 1
                        }, 8, ["height"])
                    ])
                ]),
                _: 1
            }));
        };
    }
});
